import { useMutation } from '@tanstack/react-query';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceSolvency = () => {
  return useMutation({
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceSolvency,
  });
};
